import { RetainedView } from 'api/fragments/UserSettings';
import { useCallback, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import store from 'store';
import { singlePageRoutes } from './SinglePageRoutes';
import { sharedRoutes } from '_legacy/models/SharedRoutes';

export const useRetainedAppState = () => {
    const navigate = useHistory();

    const goToRetainedPage = useCallback(
        (retainedView?: RetainedView) => {
            switch (retainedView) {
                case RetainedView.Fixtures:
                    navigate.push(singlePageRoutes.fixtures);
                    break;

                case RetainedView.Orders:
                    navigate.push(singlePageRoutes.orders);
                    break;

                case RetainedView.Multi:
                    navigate.push(sharedRoutes.multi);
                    break;
                default:
                    navigate.push(singlePageRoutes.orders);
                    break;
            }
        },
        [navigate]
    );

    useEffect(() => {
        const user = store.getState().user;
        goToRetainedPage(user.uiSettings.retainedView);
    }, [goToRetainedPage]);
};
